import React from 'react';
import { Field, FastField, FieldProps } from 'formik';
import { Slider, SliderProps } from 'src/kit';

export type FormikSliderProps = SliderProps & {
  name: string;
  isFast?: boolean;
};

const FormikSlider = ({ isFast, children, name, ...rest }: FormikSliderProps) => {
  const FieldComponent = isFast ? FastField : Field;
  return (
    <FieldComponent name={name}>
      {({ field: { value }, form: { setFieldValue } }: FieldProps) => {
        return (
          <>
            <Slider value={value} onAfterChange={v => setFieldValue(name, v)} {...rest} />
            {children}
          </>
        );
      }}
    </FieldComponent>
  );
};

export default FormikSlider;
